import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { Router } from '@angular/router';
import { SosService } from '../../core/services/sos.service';
import { environment } from '../../../environments/environment';
import { FoundationServiceService } from '../../features/services/foundation-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  isAuthenticated = false;
  username = '';
  isMenuOpen = false;
  activeSubmenu: number | null = null;
  isEnabledGafiRedirect = environment.enableGafiRedirect;
  canApplyService: boolean = false;
  canViewFreeZones: boolean = false;
  constructor(private authService: AuthService, private sosService: SosService, private router: Router,private foundationService: FoundationServiceService) {}

  ngOnInit(): void {
    // Subscribe to auth changes (login/logout)
    this.authService.authState$.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      this.username = isAuth ? this.authService.getUsername() : '';
    });

    this.foundationService.canProgressServices().subscribe((response) => {
      this.canApplyService = response.data;
    });
    //   if(this.isAuthenticated)
    // this.foundationService.canGoToFreeZone().subscribe((response) => {
    //   this.canViewFreeZones = response.data;
    // });
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (!this.isMenuOpen) {
      this.activeSubmenu = null;
    }
  }

  toggleSubmenu(event: Event, index: number): void {
    event.preventDefault(); // Always prevent default navigation
    event.stopPropagation();
    
    // Only toggle on mobile
    if (window.innerWidth <= 1585) {
      this.activeSubmenu = this.activeSubmenu === index ? null : index;
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeSubmenu = null;
  }

  get isMainServicesRoute(): boolean {
    return this.router.url.startsWith('/services/main-services');
  }

  logout(): void {
    this.authService.logout();
    this.closeMenu();
  }

  navigateToHome(): void {
    if(this.isEnabledGafiRedirect){
      window.location.href = 'https://gafi.gov.eg'
    }else{
      this.router.navigate(['/home']);
    }
    this.closeMenu(); 
  }


  // startSso(): void {
  //   if (this.isAuthenticated) {
  //     this.sosService.startSosSession();
  //   } else {
  //     // this.router.navigate(['auth/login']);
  //     window.location.href = environment.freeZonesUrl;
  //   }
  // }

  goToEServices(): void {
    if (!this.canApplyService) {
      this.showServiceDownWarning();
      return;
    }

    this.router.navigate(['/services/eServices']);
    this.closeMenu();
  }

  goToAssociations(): void {
    this.router.navigate(['/associations']);
    this.closeMenu();
  }

  getFullName(): string {
    return this.authService.getFullName();
  }

  goToFreeZones(): void {
    if (!this.canApplyService) {
      this.showServiceDownWarning();
      return;
    } else {
      // this.startSso();
      this.closeMenu();
    }
  }

  private showServiceDownWarning(): void {
      Swal.fire({
        title: 'تنبيه / Notice',
        icon: 'info',
        html: `
          <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                      text-align: center;
                      direction: rtl;
                      line-height: 1.6;
                      padding: 0 20px;
                      max-width: 100%;">
  
            <!-- Logo -->
           <!--
           <img src="http://www.gafi.gov.eg/Style%20Library/linkdevCustomImg/images/logo-1.png"
                 alt="شعار الهيئة العامة للاستثمار والمناطق الحرة"
                 style="max-width: 180px; margin: 0 auto 20px; display: block;">
                 -->
  
            <!-- Authority Name - Bigger width popup + RED color -->
            <h2 style="margin: 0 0 20px; font-size: 1.5rem; font-weight: bold; color: #c8102e;">
              الهيئة العامة للاستثمار والمناطق الحرة
            </h2>
  
            <!-- Arabic part -->
            <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
              السادة العملاء
            </h3>
            <p style="margin: 0 0 24px; font-size: 1.1rem;">
            لضمان جودة تقديم الخدمة ، يرجى العلم أن الخدمة متاحة طيلة أيام الأسبوع فيما عدا يومي الجمعة والسبت وكذلك الأجازات والعطلات الرسمية.
          </p>
  
            <!-- Separator -->
            <hr style="border: 0; border-top: 1px solid #ccc; margin: 24px 0;">
  
            <!-- English part -->
            <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
              Dear Customers
            </h3>
            <p style="margin: 0; font-size: 1.1rem;">
              To ensure quality service, please note that the service is currently unavailable.<br>
              It is available all days of the week, except Fridays and Saturdays, as well as official holidays.
            </p>
          </div>
        `,
        confirmButtonText: 'حسناً / OK',
        confirmButtonColor: '#3CBACB',
        allowOutsideClick: true,
        allowEscapeKey: true,
        showCloseButton: true,
        width: '620px', // ← Increased width here
        customClass: {
          popup: 'service-notice-popup',
        },
      });
    }
  
}
